import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import ChatIcon from "@mui/icons-material/Chat";

import { dispatchStatusConfig } from "../CampaignViewPage.utils";

export default function CampaignDispatchStatusCell({ value }) {
  const statusValue = value || "Desconhecido";
  const normalizedStatus = String(statusValue).toLowerCase();
  const config = dispatchStatusConfig[normalizedStatus] || dispatchStatusConfig.default;
  const normalizeLabel = (text) =>
    String(text || "")
      .toLowerCase()
      .replace(/^\p{L}/u, (char) => char.toUpperCase());
  const displayStatus =
    normalizedStatus === "entrega não confirmada"
      ? "Aceita"
      : normalizeLabel(statusValue);

  const renderStatusIcon = () => {
    if (normalizedStatus === "falha") {
      return <ErrorIcon sx={{ fontSize: 16, color: config.iconColor }} />;
    }

    if (normalizedStatus === "entrega não confirmada" || normalizedStatus === "desconhecido") {
      return <ErrorIcon sx={{ fontSize: 16, color: config.iconColor }} />;
    }

    if (normalizedStatus === "lida" || normalizedStatus === "entregue") {
      return <DoneAllIcon sx={{ fontSize: 16, color: config.iconColor }} />;
    }

    if (normalizedStatus === "sem whatsapp") {
      return <ErrorIcon sx={{ fontSize: 16, color: config.iconColor }} />;
    }

    return <ChatIcon sx={{ fontSize: 16, color: config.iconColor }} />;
  };

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1,
      }}
    >
      <Tooltip title={config.tooltip} arrow>
        <Box sx={{ display: "inline-flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
          {renderStatusIcon()}
        </Box>
      </Tooltip>

      <Box
        sx={{
          minWidth: 100,
          height: 24,
          px: 1.5,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "6px",
          backgroundColor: config.backgroundColor,
          border: `1px solid ${config.borderColor}`,
        }}
      >
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: 700,
            color: config.textColor,
            lineHeight: 1,
            textTransform: "none",
          }}
        >
          {displayStatus}
        </Typography>
      </Box>
    </Box>
  );
}
